"use strict";

exports.__esModule = true;
exports.STAFF_RESOURCE_GROUP_ID = exports.SEPARATOR = exports.FILTER_STAFF_BY_LOCATION_EXPERIMENT = exports.DO_NOT_CARE_STAFF = exports.ALL_DAY_MULTI_DAY_EXPERIMENT = exports.ADD_ONS_WITH_IMAGES_EXPERIMENT = void 0;
const STAFF_RESOURCE_GROUP_ID = exports.STAFF_RESOURCE_GROUP_ID = 'staff';
const SEPARATOR = exports.SEPARATOR = ' • ';
const DO_NOT_CARE_STAFF = exports.DO_NOT_CARE_STAFF = 'DO_NOT_CARE';
const ALL_DAY_MULTI_DAY_EXPERIMENT = exports.ALL_DAY_MULTI_DAY_EXPERIMENT = 'specs.bookings.AllDayMultiDayEvents';
const ADD_ONS_WITH_IMAGES_EXPERIMENT = exports.ADD_ONS_WITH_IMAGES_EXPERIMENT = 'addOnsWithImages';
const FILTER_STAFF_BY_LOCATION_EXPERIMENT = exports.FILTER_STAFF_BY_LOCATION_EXPERIMENT = 'filterPreferencesModalStaffByLocation';
//# sourceMappingURL=constants.js.map